export default __webpack_public_path__ + "static/media/shutterstock_v25087742.847cb45b.jpg";